import { gql } from '@apollo/client';

export const SAVE_SEARCH_FILTERS_GROUPS = gql`
  mutation saveSearchFiltersGroup($name: String!, $filters: ListingFiltersInput!) {
    saveSearchFiltersGroup(input: { name: $name, filters: $filters }) {
      ID
      name
    }
  }
`;
